module.exports = __webpack_public_path__ + "static/media/SERVEUR.99dffad9.mp4";